const upsellAddToCart = (event) => {
  const id = event.target.getAttribute("data-vid"),
    cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
  let formData = {
    items: [{ id, quantity: 1 }],
    sections: cart
      ? Array.from(cart.getSectionsToRender()).map((section) => section.id)
      : [],
    sections_url: window.location.pathname,
  };
  fetch(`${routes.cart_add_url}.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: "product-form",
          productVariantId: id,
          errors: response.description,
          message: response.message,
        });
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: id,
      }),
        cart.renderContents(response);
    })
    .catch((error) => console.error(error));
}
const updateUpsellBtnEvents = () => {
  const upsellButtons = document.querySelectorAll(".upsell-add-cart");
  upsellButtons.length > 0 &&
    upsellButtons.forEach((el) => {
      el.addEventListener("click", upsellAddToCart);
    });
}
document.addEventListener("DOMContentLoaded", function () {
   subscribe(PUB_SUB_EVENTS.cartUpdate, (evt) => {
    updateUpsellBtnEvents();
  });
  document.addEventListener("DrawerCartOpened", (evt) => {
    updateUpsellBtnEvents();
  });
});